import LearnPageLayout from "@/components/LearnPageLayout";
import { pageHowFastSaint } from "./learnDataHowFastSaint";

const HowFastSaintPage = () => (
  <LearnPageLayout
    title={pageHowFastSaint.title}
    description={pageHowFastSaint.description}
    canonical={pageHowFastSaint.canonical}
    h1={pageHowFastSaint.h1}
    breadcrumbLabel={pageHowFastSaint.breadcrumbLabel}
    crumbs={pageHowFastSaint.crumbs}
    shortAnswer={pageHowFastSaint.shortAnswer}
    keyTakeaways={pageHowFastSaint.keyTakeaways}
    sections={pageHowFastSaint.sections}
    faqs={pageHowFastSaint.faqs}
    sources={pageHowFastSaint.sources}
    schemaJson={pageHowFastSaint.schemaJson}
    relatedLinks={pageHowFastSaint.relatedLinks}
    reviewBlock={pageHowFastSaint.reviewBlock}
  />
);

export default HowFastSaintPage;
